import { useSelector } from "react-redux";

import { selectProfileUsername } from "@/redux/selectors/authSelectors";
import { useAcuityApprovers } from "@/features/acuity/api/queries/useAcuityApprovers";
import { useCheckPermission } from "@/features/access-control/hooks/useCheckPermission";
import { useCurrentAcuityScore } from "@/features/acuity/api/queries/useCurrentAcuityScore";
import type { UUID } from "@/core/types";

import { AcuityUpdateAlert } from "./components/AcuityUpdateAlert";
import { AcuityUpdateAlertSkeleton } from "./components/AcuityUpdateAlertSkeleton";

export function AcuityUpdateList({ patientId }: { patientId: UUID }) {
  const username = useSelector(selectProfileUsername);
  const { data: approvers } = useAcuityApprovers();

  const isAcuityApprover = useCheckPermission({
    permissionKey: "acuityScoreApprove",
    predicateContext: { approvers, username },
  });

  // TODO: useAcuityUpdates query, disabled if !isAcuityApprover
  const { data: currentAcuity, isLoading } = useCurrentAcuityScore({
    patientId,
    select: (data) => ({
      currentScore: data.effective_score?.score,
      requests: data.approval_requests,
    }),
  });

  if (!isAcuityApprover || !currentAcuity) return null;
  if (isLoading) return <AcuityUpdateAlertSkeleton />;

  return (
    <ul className="tw:contents">
      {currentAcuity?.requests.map((approvalRequest) => (
        <li key={approvalRequest.entity_id}>
          <AcuityUpdateAlert
            currentScore={currentAcuity.currentScore}
            patientId={patientId}
            {...approvalRequest}
          />
        </li>
      ))}
    </ul>
  );
}
